import { gql } from "@apollo/client";

interface response {
  code: string,
  message: string,
  success: boolean,
  id: number
}

// #region | Gate Control
export const GATE_CONTROL = gql` 
  mutation GateControl($domain: String!, $values: [StationGateControlInput!]!) {
    station {
      gateControl(domain: $domain, values: $values) {
        code
        message
        success
        id
      }
    }
  }
`

export interface stationGateControlInput {
  closeGate: boolean,
  secure: boolean,
  stationId: number
}

export interface gateControlMutation {
  domain: string, 
  values: stationGateControlInput[]
}

export interface gateControlResponse {
  station: {
    gateControl: response[]
  }
}
// #endregion

// #region | Change Gate State
export const CHANGE_GATE_STATE = gql` 
  mutation ChangeState($domain: String!, $values: [StationChangeStateInput!]!) {
    station {
      changeState(domain: $domain, values: $values) {
        code
        message
        success
        id
      }
    }
  }
`

export interface stationChangeStateInput {
  reload: boolean,
  state: number,
  stationId: number
}

export interface stationChangeStateMutation {
  domain: string, 
  values: stationChangeStateInput[]
}

export interface stationChangeStateResponse {
  station: {
    changeState: response[]
  }
}
// #endregion

// #region | Auto Tune
export const STATION_AUTO_TUNE = gql` 
  mutation AutoTune($domain: String!, $values: [StationAutoTuneInput!]!) {
    station {
      autoTune(domain: $domain, values: $values) {
        code
        message
        success
        id
      }
    }
  }
`

export interface stationAutoTuneInput {
  stationId: number,
  value: number // default 2
}

export interface stationAutoTuneMutation {
  domain: string, 
  values: stationAutoTuneInput[]
}

export interface stationAutoTuneResponse {
  station: {
    autoTune: response[]
  }
}
// #endregion